export const metatagionas = {
  Page: {
    "meta-tagi": {
      Title:
        "Tanie wakacje ze SkiOne.pl - rezerwuj wczasy, wakacje i ferie last minute",
      Description:
        "SkiOne.pl ••• Narty 2022/2023 ••• wczasy wyjazdy na narty, snowboard, góry, zimowe pensjonaty",
      Keywords: []
    }
  }
};
